//
// Search
//

export const initSearch = () => {
    const searchButton = document.querySelector('.header__buttons .btn-search');

    const updateSearchInputFieldWidth = () => {
        const searchInputField = document.querySelector('.tx-solr-searchbox .form-control');
        if (!searchInputField) {
            return;
        }
        
        const searchInputFieldWidth = searchInputField.offsetWidth;
        if (searchInputFieldWidth > 0) {
            document.documentElement.style.setProperty(
                '--search-input-field-width',
                `${searchInputFieldWidth}px`
            );
        }
    };

    updateSearchInputFieldWidth();

    // Handle search reset button
    const resetButton = document.getElementById('inputButtonReset');
    if (resetButton) {
        resetButton.addEventListener('click', () => {
            const input = resetButton.parentElement.previousElementSibling;
            if (input) {
                input.value = '';
                input.focus();
            }
        });
    }

    // Handle search button
    if (searchButton) {
        const handleSearchButtonClick = () => {
            // Wait for the search overlay to be visible
            setTimeout(() => {
                const searchInputField = document.querySelector('.tx-solr-searchbox .form-control');
                if (searchInputField) {
                    searchInputField.focus();
                    // Update width after focusing when the input is definitely visible
                    updateSearchInputFieldWidth();
                }
            }, 100);
        };

        searchButton.addEventListener('click', handleSearchButtonClick);
        
        // Return cleanup function for the event listener
        return () => {
            searchButton.removeEventListener('click', handleSearchButtonClick);
        };
    }
    
    // Update on resize with debounce for all pages
    let resizeTimeout;
    const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateSearchInputFieldWidth, 100);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Return cleanup function for the resize event
    return () => {
        window.removeEventListener('resize', handleResize);
    };
};
